var React = require('react');

function UserDropdownMenuPassword (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M13 7h-1v-3c0-2.209-1.791-4-4-4s-4 1.791-4 4v3h-1c-0.55 0-1 0.45-1 1v7c0 0.55 0.45 1 1 1h10c0.55 0 1-0.45 1-1v-7c0-0.55-0.45-1-1-1zM6 4c0-1.103 0.897-2 2-2s2 0.897 2 2v3h-4v-3zM13 10l-5 0.5 5 0.5-5 0.5 5 0.5-5 0.5 5 0.5-5 0.5 5 0.5-5 0.5 4.998 0.5c-0 0-0 0-0 0h-9.996c-0-0-0-0-0-0l4.998-0.5-5-0.5 5-0.5-5-0.5 5-0.5-5-0.5 5-0.5-5-0.5 5-0.5-5-0.5 5-0.5-5-0.5 5-0.5-4.998-0.5c0-0 0-0 0-0h9.996c0 0 0 0 0 0l-4.998 0.5 5 0.5-5 0.5 5 0.5z"}));
}

UserDropdownMenuPassword.displayName = "UserDropdownMenuPassword";

UserDropdownMenuPassword.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = UserDropdownMenuPassword;

UserDropdownMenuPassword.default = UserDropdownMenuPassword;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/user-dropdown-menu-password.svg
// module id = 1020
// module chunks = 0